export type IDelayType = 'debounce' | 'throttle';
